export const createEmpresaModel = ({
  id_empresa = '',
  razao_social = '',
  nome_fantasia = '',
  apelido = '',
  cpf_cnpj = '',
  inscricao_estadual = '',
  inscricao_municipal = '',
  endereco = '',
  numero_endereco = '',
  complemento = '',
  bairro = '',
  cidade = '',
  cep = '',
  site = '',
  email = '',
  telefone = '',
  fax = ''
} = {}) => ({
  id_empresa,
  razao_social,
  nome_fantasia,
  apelido,
  cpf_cnpj,
  inscricao_estadual,
  inscricao_municipal,
  endereco,
  numero_endereco,
  complemento,
  bairro,
  cidade,
  cep,
  site,
  email,
  telefone,
  fax
});